
































import { Component, Mixins, Prop } from "vue-property-decorator";
import CProdProvInjectorMixin from "@/mixins/cProdProvInjectorMixin";
import _ from "@/boot/lodash";

@Component
export default class CProdProvConfigDetails extends Mixins(
  CProdProvInjectorMixin
) {
  @Prop({ default: 4 })
  public readonly limit!: number;

  public showAll = false;

  public get mappedFieldValues() {
    return _.filter(
      _.map(this.cProdProvData.contractProductFields, field => {
        return {
          id: field.id,
          label: field.field_label,
          value: _.find(this.cProdProvData.contractProductFieldsValues, [
            "blueprint_field_id",
            field.id
          ])?.value
        };
      }),
      ({ value }) => !!value
    );
  }

  public get visibleFields() {
    if (this.showAll) return this.mappedFieldValues;
    return this.mappedFieldValues.slice(0, this.limit);
  }

  public get hiddenFieldCount() {
    return this.mappedFieldValues.length - this.visibleFields.length;
  }
}
